import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        backgroundColor: theme.palette.primary.main,
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        width: "100%",
        padding: "32px",
        borderRadius: "4px",
    },
    mainWrapperLoading: {
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
    },
    title: {
        color: theme.palette.info.main,
        fontSize: "18px",
        fontWeight: 400,
    },
    weatherWrapper: {
        marginTop: "18px",
        display: "flex",
        gap: "48px",
    },
    weatherImageAndMainInfoWrapper: {
        display: "flex",
        gap: "14px",
    },
    weatherImage: {
        width: "100px",
        height: "100px",
        "& img": {
            width: "100%",
            height: "100%",
        },
    },
    weatherMainInfoWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    weatherMainInfo: {
        fontSize: "14px",
        fontWeight: 600,
        textTransform: "capitalize",
        lineHeight: "normal",
    },
    weatherMainInfoTemperature: {
        fontSize: "28px",
        fontWeight: 800,
        lineHeight: "normal",
    },
    weatherMainInfoTemperatureCelsius: {
        fontSize: "24px",
        fontWeight: 400,
        lineHeight: "normal",
    },
    weatherDetailsWrapper: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        columnGap: "12px",
    },
    weatherDetailsLabel: {
        fontSize: "14px",
        fontWeight: 700,
        textAlign: "right",
    },
    weatherDetailsValue: {
        fontSize: "14px",
    },
}));
